export default __webpack_public_path__ + "static/media/promos-4.02579bd8.webp";